import { redirect } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';

export async function loader(/*{ request }*/) {
	const { isSignedIn } = useUserStore.getState();
	if (isSignedIn()) {
		return redirect('/submitRequest');
	} else {
		return redirect('/login');
	}
}

const CheckProfile = () => {
	return (
		<div className="page check-profile">
			<div className="sm:mx-auto sm:w-full sm:max-w-2xl">Placeholder</div>
		</div>
	);
};

export default CheckProfile;
